let count = 0;
export default function() {
  count += 1;
  return Math.random().toString(36).substring(2, 15) + count;
}
